import React from 'react';
import { Row, Col, Spinner } from 'reactstrap';
import { FormattedMessage } from 'react-intl';


/**
 *
 * @param props
 */
export const TableInitLoading: React.FC<{}> = (): JSX.Element => {

  return (
    <Row>
      <Col sm="12" md="12" className="table-empty text-center">

        <div className="d-flex justify-content-center py-5">
            <Spinner type="grow" color="primary" size="xl">Daten werden geladen</Spinner>
        </div>
        <div className="lead">
          <FormattedMessage id="datatable_loading"/>
        </div>
      </Col>
    </Row>
  );
}



